module.exports = __webpack_public_path__ + "static/media/ida_norwegian.6134f475.mp3";